
const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const footerLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Projects', href: '#projects' },
    { name: 'Skills', href: '#skills' },
    { name: 'Contact', href: '#contact' },
  ];
  
  const policyLinks = [
    { name: 'Privacy Policy', href: '#' },
    { name: 'Terms of Service', href: '#' },
  ];

  return (
    <footer className="bg-forest text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand Column */}
          <div>
            <div className="font-pixel text-2xl mb-4">PixelCraft</div>
            <p className="font-mono text-sm text-white/80 mb-4">
              Building digital experiences with pixel-perfect precision.
            </p>
            <div className="flex space-x-4">
              {/* Social icons */}
              <a href="#" className="w-8 h-8 bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
                <span className="font-pixel text-xs">G</span>
              </a>
              <a href="#" className="w-8 h-8 bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
                <span className="font-pixel text-xs">T</span>
              </a>
              <a href="#" className="w-8 h-8 bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
                <span className="font-pixel text-xs">L</span>
              </a>
              <a href="#" className="w-8 h-8 bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
                <span className="font-pixel text-xs">I</span>
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-pixel text-sm mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.href} 
                    className="font-mono text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h3 className="font-pixel text-sm mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="font-mono text-sm text-white/80">alex@pixeldev.example</li>
              <li className="font-mono text-sm text-white/80">Pixel Valley, Digital World</li>
              <li className="font-mono text-sm text-white/80">Available for freelance work</li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center">
          <div className="font-mono text-xs text-white/70 mb-4 md:mb-0">
            © {currentYear} Pixel.Dev. All rights reserved.
          </div>
          
          <div className="flex space-x-6">
            {policyLinks.map((link) => (
              <a 
                key={link.name}
                href={link.href} 
                className="font-mono text-xs text-white/70 hover:text-white transition-colors"
              >
                {link.name}
              </a>
            ))}
          </div>
        </div>
        
        {/* Pixel Art Footer Decoration */}
        <div className="mt-8 border-t-2 border-dashed border-white/30 pt-2">
          <div className="flex justify-center space-x-2">
            <div className="w-2 h-2 bg-grass"></div>
            <div className="w-2 h-2 bg-water"></div>
            <div className="w-2 h-2 bg-flower-yellow"></div>
            <div className="w-2 h-2 bg-flower-purple"></div>
            <div className="w-2 h-2 bg-flower-red"></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;